var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A) Icons / Navigation / Chevron Left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A)-Icons-/-Navigation-/-Chevron-Left",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron-Left",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0795049,3.70450487 C15.5188447,3.26516504 16.2311553,3.26516504 16.6704951,3.70450487 C17.1012205,4.13523019 17.109666,4.8283265 16.6958319,5.26934088 L16.6704951,5.29549513 L9.965875,12 L16.6704951,18.7045049 C17.1012205,19.1352302 17.109666,19.8283265 16.6958319,20.2693409 L16.6704951,20.2954951 C16.2397698,20.7262205 15.5466735,20.734666 15.1056591,20.3208319 L15.0795049,20.2954951 L7.57950487,12.7954951 C7.14877955,12.3647698 7.14033395,11.6716735 7.55416809,11.2306591 L7.57950487,11.2045049 L15.0795049,3.70450487 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.b1ba4019.svg";
export { ForwardRef as ReactComponent };